import { Box } from '@byecode/ui'
import type { OtherPlatformType } from '@lighthouse/shared'
import React from 'react'

import { IntegratedCard } from '@/components/IntegratedCard'

import * as CM from '../styles'

interface ActionAuthIntegrateCardProps {
    type: OtherPlatformType
}

export const ActionAuthIntegrateCard: React.FunctionComponent<ActionAuthIntegrateCardProps> = ({ type }) => {
    return (
        <CM.ActionGroup label="授权配置">
            <Box py={4} px={8}>
                <IntegratedCard type={type} />
            </Box>
        </CM.ActionGroup>
    )
}
